module.exports = __webpack_public_path__ + "img/12.38f533d1.webp";